import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../consts";

export class GameContextCloseHandler extends ActionHandler {
  type: ACTION_TYPES;

  static injectables = [...ActionHandler.injectables];

  constructor() {
    super();

    this.type = ACTION_TYPES.onGameContextClose;
  }

  async action(params) {
    this.appStore.state.context.setSelectedGame(null);
  }
}
